// extracted by mini-css-extract-plugin
module.exports = {"tableTooltip":"Tooltip_tableTooltip__3HbIw","toolTipIcon":"Tooltip_toolTipIcon__RZi6D"};